import { GatewayClientProvider } from './../gateway-client/gateway-client';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

/*
  Generated class for the GoalsProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class ChequeProvider {

  constructor(public gateway: GatewayClientProvider) {

  }

  getChequesByAccountid(accountid) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getChequesByAccountid(accountid)
        .then((data) => {
          resolve(data);
        }).catch((error) => {
          reject(error);
        })
    });
  }

  addCheque(cheque) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.addCheque(cheque)
        .then(() => {
          resolve({});
        }).catch((error) => {
          reject(error);
        })
    });
  }
  updateCheque(account, goal) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.updateCheque(account, goal)
        .then(() => {
          resolve({});
        }).catch((error) => {
          reject(error);
        })
    });
  }
  removeCheque(account, goal) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.removeCheque(account, goal)
        .then(() => {
          resolve({});
        }).catch((error) => {
          reject(error);
        })
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/cheque/chequeprovider.ts